module.exports = __webpack_public_path__ + "static/img/fund.81110a3c.svg";